import React from 'react';
import { IEventUScore, IActiveDimension } from '../../interfaces';
import { effectOptions } from '../scoringPage/consts';
import { filter, groupBy, keys, map, size, sumBy, isEmpty } from 'lodash/fp';
import { getDimensionLongName } from 'utils/riskUtils';
import {
    FGIcons,
    FGStack,
    FGTile,
    FGTooltip,
    FGTypography,
    TOOLTIP_PLACEMENT,
} from '@fg/design-system';
import { EventCircle } from './EventCircle';
interface Props {
    scores: IEventUScore[];
    dimensions: { [dimensionId: number]: IActiveDimension };
}
const ScoresImpact = React.memo((props: Props) => {
    const findImpactByValue = (val: number) => {
        for (const option of effectOptions) {
            if (option.isBelong(val)) {
                return option;
            }
        }
    };
    const dimensionGroups = groupBy(item => item.dimension_id, props.scores);
    let dimensionKeys = keys(dimensionGroups);
    //todo: delete after fixing missing dimensions
    dimensionKeys = filter(dimId => !!props.dimensions[dimId], dimensionKeys);
    //todo: refine once we actually know what an average impact means
    const calcAvgImpact = (scores: IEventUScore[]) => {
        const sum = sumBy(score => score.impact, scores);
        return sum / size(scores);
    };
    const hasHumanScores =
        !isEmpty(props.scores) && !!props.scores.find(score => score.human);
    return (
        <FGStack direction="column" gap={4}>
            {map((dimId: number) => {
                const scoresForDimension: IEventUScore[] =
                    dimensionGroups[dimId];
                const avgImpact = calcAvgImpact(scoresForDimension);
                if (!props.dimensions[dimId]) {
                    console.log('wrong', dimId);
                }
                const impact = findImpactByValue(avgImpact);
                return (
                    <FGStack
                        key={dimId}
                        alignItems="center"
                        gap={4}
                        style={{ pointerEvents: 'all' }}>
                        <FGTooltip
                            placement={TOOLTIP_PLACEMENT.top}
                            appendTo={'parent'}
                            content={
                                <FGStack alignItems="center" gap={4}>
                                    <EventCircle color={impact.color} />
                                    <FGTypography
                                        variant="body4"
                                        color="strong"
                                        tag="label">
                                        {impact.text} Impact
                                    </FGTypography>
                                </FGStack>
                            }>
                            <div>
                                <ImpactTile>
                                    <EventCircle color={impact.color} />
                                </ImpactTile>
                            </div>
                        </FGTooltip>
                        <ImpactTile>
                            <FGTypography
                                variant="body4"
                                tag="label"
                                color="strong">
                                {`${getDimensionLongName(
                                    props.dimensions[dimId]
                                )} (${size(scoresForDimension)})`}
                            </FGTypography>
                        </ImpactTile>
                        {hasHumanScores && (
                            <ImpactTile>
                                <FGIcons icon="Contact" size={12} />
                            </ImpactTile>
                        )}
                    </FGStack>
                );
            }, dimensionKeys)}
        </FGStack>
    );
});

const ImpactTile = React.memo(({ children }: { children: React.ReactNode }) => {
    return (
        <FGTile
            padding="small"
            style={{
                width: 'auto',
                height: 20,
                borderRadius: 3,
                backgroundColor: 'var(--fg-color-surface-secondary)',
            }}>
            {children}
        </FGTile>
    );
});

export default ScoresImpact;
